module.exports = __webpack_public_path__ + "img/热销商品4.13bfe537.png";